"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _reactModal = _interopRequireDefault(require("../../components/reactModal"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _logger = require("@insided/shared/services/logger");

var _AccordionPanel = _interopRequireDefault(require("../panel/AccordionPanel"));

var _KeywordBlockerPanel = require("./KeywordBlockerPanel");

var _axios = _interopRequireDefault(require("axios"));

var _ModeratorApprovalPanel = require("./ModeratorApprovalPanel");

var _ContentModeration = require("@insided/control/modules/ContentModeration");

var _UserProfileModeration = require("@insided/control/modules/ContentModeration/UserProfileModeration");

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PremoderationRules = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PremoderationRules, _Component);

  var _super = _createSuper(PremoderationRules);

  function PremoderationRules() {
    var _this;

    (0, _classCallCheck2.default)(this, PremoderationRules);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      storedState: {
        keywordBlockerSetting: _this.props.keywordBlockerSetting,
        blockedKeywords: _this.props.blockedKeywords,
        moderatorApprovalSetting: _this.props.moderatorApprovalSetting,
        userProfileModerationSetting: _this.props.userProfileModerationSetting
      },
      isKeywordBlockerEnabled: _this.props.keywordBlockerSetting,
      blockedWords: _this.props.blockedKeywords,
      showKeywordBlockerActionButtons: false,
      isModeratorApprovalEnabled: _this.props.moderatorApprovalSetting,
      showModeratorApprovalActionButtons: false,
      showValidationError: false,
      showUnsavedChangesModal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUnload", function (e) {
      if (_this.hasPanelHasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onKeywordBlockerSettingChanged", function (value) {
      var _this$state$storedSta = _this.state.storedState,
          keywordBlockerSetting = _this$state$storedSta.keywordBlockerSetting,
          blockedKeywords = _this$state$storedSta.blockedKeywords; // eslint-disable-next-line react/no-access-state-in-setstate

      var showActionButtons = keywordBlockerSetting !== value || blockedKeywords !== _this.state.blockedWords;

      if (!value) {
        _this.setState({
          showValidationError: false
        });
      }

      _this.setState({
        isKeywordBlockerEnabled: value,
        showKeywordBlockerActionButtons: showActionButtons,
        activePanel: 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBlockedWordsChanged", function (value) {
      if (value === '') {
        _this.setState({
          blockedWords: [],
          showValidationError: true,
          showKeywordBlockerActionButtons: true
        });

        return;
      }

      var words = value.split(',').map(function (word) {
        return word.trim();
      }); // eslint-disable-next-line react/no-access-state-in-setstate

      var showActionButtons = _this.state.storedState.blockedKeywords !== words;

      _this.setState({
        blockedWords: words,
        showKeywordBlockerActionButtons: showActionButtons,
        showValidationError: false,
        activePanel: 0
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onFocusBlockedWords", function () {
      if (_this.state.showKeywordBlockerActionButtons) {
        return;
      }

      _this.setState({
        showKeywordBlockerActionButtons: true,
        showValidationError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveKeywordBlockerSetting", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$state$blockedWo;

      var successMessage, errorMessage, updatedState, _e$response, _e$response2;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(((_this$state$blockedWo = _this.state.blockedWords) === null || _this$state$blockedWo === void 0 ? void 0 : _this$state$blockedWo.length) === 0 && _this.state.isKeywordBlockerEnabled)) {
                _context.next = 3;
                break;
              }

              _this.setState({
                showValidationError: true
              });

              return _context.abrupt("return");

            case 3:
              _this.setState({
                messageType: null
              });

              successMessage = "'Keyword blocker' settings have been updated successfully.";
              errorMessage = "Something went wrong, settings can't be updated. Please try again.";
              _context.prev = 6;
              _context.next = 9;
              return _axios.default.post('/settings/premoderation/keywordBlocker', {
                isKeywordBlockerEnabled: _this.state.isKeywordBlockerEnabled,
                blockedWords: _this.state.blockedWords
              });

            case 9:
              // eslint-disable-next-line react/no-access-state-in-setstate
              updatedState = _this.state.storedState;
              updatedState.blockedKeywords = _this.state.blockedWords;
              updatedState.keywordBlockerSetting = _this.state.isKeywordBlockerEnabled;

              _this.setState({
                storedState: updatedState,
                message: successMessage,
                messageType: 'success',
                showKeywordBlockerActionButtons: false
              });

              _context.next = 19;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);

              if (((_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : _e$response.status) === 422 && (_e$response2 = _context.t0.response) !== null && _e$response2 !== void 0 && _e$response2.data) {
                errorMessage = _context.t0.response.data;
              }

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showKeywordBlockerActionButtons: false
              });

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 15]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetKeywordBlockerSettings", function () {
      var _this$state$storedSta2 = _this.state.storedState,
          keywordBlockerSetting = _this$state$storedSta2.keywordBlockerSetting,
          blockedKeywords = _this$state$storedSta2.blockedKeywords;

      _this.setState({
        isKeywordBlockerEnabled: keywordBlockerSetting,
        blockedWords: blockedKeywords,
        showKeywordBlockerActionButtons: false,
        showValidationError: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onModeratorApprovalChanged", function (value) {
      // eslint-disable-next-line react/no-access-state-in-setstate
      var showActionButtons = _this.state.storedState.moderatorApprovalSetting !== value;

      _this.setState({
        isModeratorApprovalEnabled: value,
        showModeratorApprovalActionButtons: showActionButtons,
        activePanel: 1
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "saveModeratorApprovalSetting", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var successMessage, errorMessage, updatedState;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                messageType: null
              });

              successMessage = "'Moderator approval' setting has been updated successfully.";
              errorMessage = "Something went wrong, setting can't be updated. Please try again.";
              _context2.prev = 3;
              _context2.next = 6;
              return _axios.default.post('/settings/premoderation/moderatorApproval', {
                isModeratorApprovalEnabled: _this.state.isModeratorApprovalEnabled
              });

            case 6:
              // eslint-disable-next-line react/no-access-state-in-setstate
              updatedState = _this.state.storedState;
              updatedState.moderatorApprovalSetting = _this.state.isModeratorApprovalEnabled;

              _this.setState({
                storedState: updatedState,
                message: successMessage,
                messageType: 'success',
                showModeratorApprovalActionButtons: false
              });

              _context2.next = 15;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);

              _logger.logger.error(_context2.t0, {
                component: 'PremoderationRules',
                action: 'saveModeratorApprovalSetting'
              });

              _this.setState({
                messageType: 'error',
                message: errorMessage,
                showModeratorApprovalActionButtons: false
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 11]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetModeratorApprovalSetting", function () {
      _this.setState({
        // eslint-disable-next-line react/no-access-state-in-setstate
        isModeratorApprovalEnabled: _this.state.storedState.moderatorApprovalSetting,
        showModeratorApprovalActionButtons: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "closeModal", function () {
      _this.setState({
        showUnsavedChangesModal: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetChanges", function () {
      var _this$state$storedSta3 = _this.state.storedState,
          keywordBlockerSetting = _this$state$storedSta3.keywordBlockerSetting,
          blockedKeywords = _this$state$storedSta3.blockedKeywords,
          moderatorApprovalSetting = _this$state$storedSta3.moderatorApprovalSetting;
      var hasKeywordBlockerSettingChanged = keywordBlockerSetting !== _this.state.isKeywordBlockerEnabled;
      var hasBlockedKeywordsChanged = blockedKeywords !== _this.state.blockedWords;
      var keywordBlockerSettingsChanged = hasKeywordBlockerSettingChanged || hasBlockedKeywordsChanged;

      if (keywordBlockerSettingsChanged) {
        _this.setState({
          activePanel: 1
        });

        _this.resetKeywordBlockerSettings();
      }

      if (moderatorApprovalSetting !== _this.state.isModeratorApprovalEnabled) {
        _this.setState({
          activePanel: 0
        });

        _this.resetModeratorApprovalSetting();
      }

      _this.setState({
        showUnsavedChangesModal: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(PremoderationRules, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "hasPanelHasUnsavedChanges",
    get: function get() {
      var _this$state$storedSta4 = this.state.storedState,
          keywordBlockerSetting = _this$state$storedSta4.keywordBlockerSetting,
          blockedKeywords = _this$state$storedSta4.blockedKeywords,
          moderatorApprovalSetting = _this$state$storedSta4.moderatorApprovalSetting;
      var hasKeywordBlockerSettingChanged = keywordBlockerSetting !== this.state.isKeywordBlockerEnabled;
      var hasBlockedKeywordsChanged = blockedKeywords !== this.state.blockedWords;
      var hasModeratorApprovalSettingChanged = moderatorApprovalSetting !== this.state.isModeratorApprovalEnabled;
      return hasKeywordBlockerSettingChanged || hasBlockedKeywordsChanged || hasModeratorApprovalSettingChanged;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          storedState = _this$state.storedState,
          isKeywordBlockerEnabled = _this$state.isKeywordBlockerEnabled,
          blockedWords = _this$state.blockedWords,
          showKeywordBlockerActionButtons = _this$state.showKeywordBlockerActionButtons,
          showValidationError = _this$state.showValidationError,
          message = _this$state.message,
          messageType = _this$state.messageType,
          showUnsavedChangesModal = _this$state.showUnsavedChangesModal,
          isModeratorApprovalEnabled = _this$state.isModeratorApprovalEnabled,
          showModeratorApprovalActionButtons = _this$state.showModeratorApprovalActionButtons,
          activePanel = _this$state.activePanel;
      var KeywordBlockerPanel = {
        title: (0, _preact.h)(_KeywordBlockerPanel.KeywordBlockerPanelHeader, {
          statusText: storedState.keywordBlockerSetting ? 'on' : 'off'
        }),
        body: (0, _preact.h)(_KeywordBlockerPanel.KeywordBlockerPanelBody, {
          isKeywordBlockerEnabled: isKeywordBlockerEnabled,
          blockedWords: blockedWords,
          showActionButtons: showKeywordBlockerActionButtons,
          showValidationError: showValidationError,
          onSave: this.saveKeywordBlockerSetting,
          onCancel: this.resetKeywordBlockerSettings,
          onTextareaFocus: this.onFocusBlockedWords,
          onKeywordBlockerSettingChanged: function onKeywordBlockerSettingChanged() {
            return _this2.onKeywordBlockerSettingChanged(!isKeywordBlockerEnabled);
          },
          onBlockedWordsChanged: function onBlockedWordsChanged(value) {
            return _this2.onBlockedWordsChanged(value.trim());
          }
        }),
        hasUnsavedChanges: this.hasPanelHasUnsavedChanges
      };
      var ModeratorApprovalPanel = {
        title: (0, _preact.h)(_ModeratorApprovalPanel.ModeratorApprovalPanelHeader, {
          statusText: storedState.moderatorApprovalSetting ? 'on' : 'off'
        }),
        body: (0, _preact.h)(_ModeratorApprovalPanel.ModeratorApprovalPanelBody, {
          isModeratorApprovalEnabled: isModeratorApprovalEnabled,
          onModeratorApprovalChanged: function onModeratorApprovalChanged() {
            return _this2.onModeratorApprovalChanged(!isModeratorApprovalEnabled);
          },
          showActionButtons: showModeratorApprovalActionButtons,
          onSave: this.saveModeratorApprovalSetting,
          onCancel: this.resetModeratorApprovalSetting
        }),
        hasUnsavedChanges: this.hasPanelHasUnsavedChanges
      };
      return (0, _preact.h)("div", {
        className: "premoderation-rules-overview qa-premoderation-rules-overview"
      }, (0, _preact.h)(_header.default, {
        title: "Pre-moderation Rules",
        disableCancelButton: true,
        disableSaveButton: true
      }), Boolean(messageType) && (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        renderHTML: true,
        isVisibleFor: messageType === 'success' ? 5000 : false
      }), (0, _preact.h)(_AccordionPanel.default, {
        defaultActivePanelIndex: activePanel,
        panels: [KeywordBlockerPanel, ModeratorApprovalPanel],
        renderUnsavedChangesModal: function renderUnsavedChangesModal() {
          return _this2.setState({
            showUnsavedChangesModal: true
          });
        }
      }), !_common.common.isModuleActive('AIControlNavigationSettings') && (_common.common.isModuleActive('aiModeratorKit') || _common.common.isModuleActive('aiEvolutionUserProfileModeration')) && (0, _preact.h)("div", {
        className: "moderator-kit-container"
      }, (0, _preact.h)("h2", {
        className: "moderator-kit-heading"
      }, "AI Moderation"), _common.common.isModuleActive('aiModeratorKit') && (0, _preact.h)(_ContentModeration.ModeratorKitContainer, {
        hideHeading: true
      }), _common.common.isModuleActive('aiEvolutionUserProfileModeration') && (0, _preact.h)(_UserProfileModeration.UserProfileModerationContainer, {
        isUserProfileModerationEnabled: this.props.userProfileModerationSetting
      })), (0, _preact.h)(_reactModal.default, {
        isOpen: showUnsavedChangesModal,
        onClose: this.closeModal
      }, (0, _preact.h)("div", {
        className: "unsaved-changes-modal"
      }, (0, _preact.h)("h3", {
        className: "modal-title"
      }, "Unsaved Changes"), (0, _preact.h)("div", {
        className: "modal-description"
      }, "You have unsaved changes. Do you want to discard them?"), (0, _preact.h)(_buttonControl.default, {
        size: "medium",
        variant: "brand",
        newStyle: true,
        title: "Discard changes",
        onClick: this.resetChanges
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        size: "medium",
        title: "Cancel",
        onClick: this.closeModal
      }))));
    }
  }]);
  return PremoderationRules;
}(_preact.Component);

var _default = PremoderationRules;
exports.default = _default;